import {useTranslation} from '@aboutyou/i18n';
import React from 'react';
import styled, {css} from 'styled-components';
import {mobileOnly, tabletAndUp} from '../../../constants/customMedia';
import {Badge} from '../../molecules/BadgeList';
import {
  SliderTile,
  SliderTileProps,
} from '../../molecules/SliderTile/SliderTile';

interface SliderTileWithBadgeProps extends SliderTileProps {
  isPremium: boolean;
  className?: string;
  onClick?: VoidFunction;
}

export const SliderTileWithBadge: React.FC<SliderTileWithBadgeProps> = ({
  testId,
  image,
  subline,
  isPremium,
  headline,
  textsPosition,
  imageRatio,
  to,
  ctaLabel,
  onClick,
}) => {
  const {t} = useTranslation();
  const premium = t('Premium');
  return (
    <Container
      key={testId}
      data-testid={`sliderTileWithBadge-${testId}`}
      onClick={onClick}
    >
      <StyledSliderTile
        testId={testId}
        image={image}
        headline={headline}
        subline={subline}
        to={to}
        imageRatio={imageRatio}
        textsPosition={textsPosition}
        ctaLabel={ctaLabel}
      />
      {isPremium && (
        <StyledBadge
          dataTestId={'premiumBadge'}
          text={premium}
          disableRoundedCorners
        />
      )}
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  margin-bottom: 2rem;

  ${mobileOnly(css`
    margin-bottom: 0;
  `)}
`;

const StyledSliderTile = styled(SliderTile)`
  margin: 0;

  ${tabletAndUp(css`
    margin-right: 6px;
  `)}
`;

const StyledBadge = styled(Badge)`
  position: absolute;
  top: 3rem;
`;
